export default __webpack_public_path__ + "static/media/students-new.19b79920.svg";